import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DittaRoutingModule } from './ditta-routing.module';
import { DittaComponent } from './ditta.component';
import { DittaFormComponent } from './ditta-form/ditta-form.component';
import { FormsModule } from '@angular/forms';
import { DittaViewComponent } from './ditta-view/ditta-view.component';
import { DittaCreateComponent } from './ditta-create/ditta-create.component';
import { DittaDetailsComponent } from './ditta-details/ditta-details.component';
import { DittaEditComponent } from './ditta-edit/ditta-edit.component';
import { AddressModule } from '../address/address.module';
import { MyCustomMaterialModule } from 'san-common';



@NgModule({
  declarations: [DittaComponent,
    DittaCreateComponent,
    DittaDetailsComponent,
    DittaEditComponent,
    DittaViewComponent,DittaFormComponent
  ],
  imports: [
    CommonModule,
    DittaRoutingModule,
    FormsModule,
    MyCustomMaterialModule,
    AddressModule
    
    
  ],
  exports: [DittaComponent,
    DittaCreateComponent,
    DittaDetailsComponent,
    DittaEditComponent,
    DittaViewComponent,
    DittaFormComponent
   
  ]
})
export class DittaModule { }
